import { vars } from '../vars.css';

const sizes = {
  full: '100%',
  half: '50%',
  fitContent: 'fit-content',
};

const space = {
  ...vars.space,
  none: 0,
  auto: 'auto',
} as const;

export const responsiveProperties = {
  display: {
    none: 'none',
    block: 'block',
    inline: 'inline',
    inlineBlock: 'inline-block',
    flex: 'flex',
  },
  position: ['relative', 'absolute', 'fixed', 'sticky'],
  borderRadius: {
    none: '0px',
    full: '9999px',
    ...vars.border.radius,
  },
  paddingTop: space,
  paddingBottom: space,
  paddingRight: space,
  paddingLeft: space,
  marginTop: space,
  marginBottom: space,
  marginRight: space,
  marginLeft: space,
  gap: space,
  alignItems: {
    flexStart: 'flex-start',
    center: 'center',
    flexEnd: 'flex-end',
    stretch: 'stretch',
  },
  justifyContent: {
    flexStart: 'flex-start',
    center: 'center',
    flexEnd: 'flex-end',
    spaceBetween: 'space-between',
    spaceAround: 'space-around',
  },
  flexDirection: {
    row: 'row',
    rowReverse: 'row-reverse',
    column: 'column',
    columnReverse: 'column-reverse',
  },
  flexWrap: {
    wrap: 'wrap',
    nowrap: 'nowrap',
  },
  flexShrink: [0],
  flexGrow: [0, 1],
  textAlign: ['left', 'center', 'right'],
} as const;

export const unresponsiveProperties = {
  overflow: ['hidden', 'scroll', 'visible', 'auto'],
  outline: ['none'],
  opacity: [0],
  cursor: ['default', 'pointer'],
  pointerEvents: ['none'],
  top: [0],
  bottom: [0],
  left: [0],
  right: [0],
  textTransform: ['none', 'lowercase', 'uppercase', 'capitalize'],
  textDecoration: ['underline', 'line-through'],
  height: sizes,
  width: sizes,
  minWidth: {
    0: '0%',
    50: '50%',
  },
  userSelect: ['none'],
  zIndex: {
    footer: 10,
    /**
     * Content that sits above other content, but adjacent to a target element.
     * Example - card edit field popover
     * */
    popover: 1000,
    /** Content that sits above other content, but adjacent to a target element */
    tooltip: 1101,
    /** Toast notifications */
    toast: 1010,
    /** Content that sits above other content, outside of regular document flow */
    modal: 1100,
    /** Content that should sit above all other content */
    overlay: 1200,
  },
} as const;
